import * as SwitchPrimitive from "@radix-ui/react-switch";
import { forwardRef } from "react";
import { margin } from "styled-system";
import styled from "styled-components";
import { LoadingOutlined } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingIcon = styled(LoadingOutlined).withConfig({
  displayName: "switch__LoadingIcon",
  componentId: "sc-8atupy-0"
})(["position:relative;vertical-align:top;top:var(--thumb-margin);left:var(--thumb-margin);color:", ";"], p => p.theme.colors.alpha.black[7]);
const SwitchThumb = styled(SwitchPrimitive.Thumb).withConfig({
  displayName: "switch__SwitchThumb",
  componentId: "sc-8atupy-1"
})(["position:absolute;top:var(--thumb-margin);left:var(--thumb-margin);width:var(--thumb-size);height:var(--thumb-size);transition:all 0.2s ease-in-out;will-change:left;&::before{position:absolute;top:0;right:0;bottom:0;left:0;background:#fff;border-radius:100px;box-shadow:0 2px 4px 0 ", ";transition:all 0.2s ease-in-out;content:\"\";}"], p => p.theme.colors.shadow.base);
const SwitchContent = styled.span.withConfig({
  displayName: "switch__SwitchContent",
  componentId: "sc-8atupy-2"
})(["display:block;font-size:", "px;color:#fff;margin:0 7px 0 25px;transition:margin 0.2s;"], p => p.theme.fontSizes.sm);
export const SwitchRoot = styled(SwitchPrimitive.Root).withConfig({
  displayName: "switch__SwitchRoot",
  componentId: "sc-8atupy-3"
})(["--thumb-size:18px;--thumb-margin:2px;all:unset;position:relative;display:inline-block;box-sizing:border-box;vertical-align:middle;border:0;border-radius:100px;min-width:44px;height:22px;line-height:22px;background:", ";transition:all 0.2s;user-select:none;cursor:pointer;", " &:not([data-disabled]):hover{background:", ";}&:focus-visible{outline:4px solid ", ";outline-offset:1px;transition:outline-offset 0s,outline 0s;}&[data-size=\"small\"]{--thumb-size:12px;min-width:28px;height:16px;line-height:16px;", "{font-size:8px;}", "{margin:0 5px 0 18px;}&[data-state=\"checked\"]{", "{margin:0 18px 0 5px;}}}&[data-state=\"unchecked\"] span[data-checked-content]{display:none;}&[data-state=\"checked\"] span[data-unchecked-content]{display:none;}&[data-state=\"checked\"]{background:", ";&:not([data-disabled]):hover{background:", ";}", "{left:calc(100% - var(--thumb-size) - var(--thumb-margin));}", "{color:", ";}", "{margin:0 25px 0 7px;}}&:not([data-disabled]):active{", "::before{right:-30%;left:0;}&[data-state=\"checked\"]{", "::before{right:0;left:-30%;}}}&[data-disabled]{opacity:0.4;cursor:not-allowed;*{box-shadow:none;cursor:not-allowed;}}"], p => p.theme.colors.disabled, margin, p => p.theme.colors.alpha[5], p => p.theme.colors.focus, LoadingIcon, SwitchContent, SwitchContent, p => p.theme.colors.primary.base, p => p.theme.colors.primary.hover, SwitchThumb, LoadingIcon, p => p.theme.colors.primary.base, SwitchContent, SwitchThumb, SwitchThumb);
export const Switch = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    size,
    disabled,
    loading,
    onChange,
    checkedContent,
    uncheckedContent,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(SwitchRoot, {
    ref: ref,
    ...rest,
    type: "button",
    disabled: disabled || loading,
    onCheckedChange: onChange,
    "data-size": size,
    children: [/*#__PURE__*/_jsx(SwitchThumb, {
      children: loading ? /*#__PURE__*/_jsx(LoadingIcon, {}) : null
    }), /*#__PURE__*/_jsxs(SwitchContent, {
      children: [/*#__PURE__*/_jsx("span", {
        "data-checked-content": true,
        children: checkedContent
      }), /*#__PURE__*/_jsx("span", {
        "data-unchecked-content": true,
        children: uncheckedContent
      })]
    })]
  });
});

// @ts-ignore
Switch.name = "Switch"; // Used by the Field component to determine input type.
Switch.displayName = "Switch";
export default Switch;